import ApiFactory from '../factories/ApiFactory';
import { serialize } from '@/services/UtilityService';

const getDiscountsList = (filters) => {
	return new Promise((resolve, reject) => {
		const query = serialize(filters);
		ApiFactory.get(`/posweb/v1/discounts?${query}`).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const getDiscountById = (id) => {
	return new Promise((resolve, reject) => {
		ApiFactory.get(`/posweb/v1/discounts/${id}`).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

export default {
	getDiscountsList,
	getDiscountById,
};
